import React from 'react';
import { connect } from 'react-redux'
import classnames from "classnames"

import _ from "lodash";
import logoChr from "./assets/logo-chr.png";

import { Link } from "react-router-dom";

import Master from './Components/Master';
import { doLoad, select, socket} from './Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import store from './Redux';
import { withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

import MenuIcon from '@material-ui/icons/Menu';
import PermIdentity from '@material-ui/icons/PermIdentity';
import HighlightOff from '@material-ui/icons/HighlightOff';

import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';

import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Explore from '@material-ui/icons/Explore';
import FormatLineSpacing from '@material-ui/icons/FormatLineSpacing';
import Cached from '@material-ui/icons/Cached';
import Directions from '@material-ui/icons/Directions';
import WatchLater from '@material-ui/icons/WatchLater';
import EuroSymbol from '@material-ui/icons/EuroSymbol';
import Stars from '@material-ui/icons/Stars';
import SettingsIcon from '@material-ui/icons/Settings';
import HourglassEmpty from '@material-ui/icons/HourglassEmpty';
import HomeIcon from '@material-ui/icons/Home';

const ENDPOINT = "me"

const styles = theme => ({
    palette: {
        primary: {
            main: "#0165a1",
            light: "#eee",
            dark: "#eee",
        },
    },
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3,
        paddingTop: "90px",
        height: "calc(100vh - 115px)",
        overflow: "auto"
    },
    logoHeight: {
        height: "60px"
    },
    logoBar: {
        paddingLeft: 4,
        backgroundColor: "#0165a1"
    },
    flex: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
        flexBasis: "auto",
        flex: "auto"
    },
    logout: {
        flexGrow: 1,
        textAligt: "right"
    }
});

var nav = [
    {
        title: "",
        icon: <HomeIcon />,
        to: "/",
        gruppe: ["disponent", "zeiterfassung"]
    },
    {
        title: "System",
        icon: <SettingsIcon />,
        to: "/system",
        gruppe: ["admin"]
    },
    {
        title: "Verwaltung",
        icon: <TransferWithinAStationIcon />,
        sub: [
            {
                title: "Mitarbeiter",
                to: "/mitarbeiter"
            },
            {
                title: "Fuhrpark",
                to: "/fuhrpark"
            },
            {
                title: "Kontakte",
                to: "/kontakte"
            },
        ],
        gruppe: ["disponent"]
    },
    {
        title: "Fahrpläne",
        to: "/fahrplan",
        icon: <Explore />,
        gruppe: ["disponent"]
    },
    {
        title: "Umlaufpläne",
        to: "/umlaufplan",
        icon: <Cached />,
        gruppe: ["disponent", "zeiterfassung"]
    },
    {
        title: "Leitstand",
        to: "/dienstplan",
        icon: <Directions />,
        gruppe: ["disponent"]
        /*sub: [
            {
                title: "Disposition",
                to: "/dienstplan",
                icon: <Directions />,
            }
        ]*/
    },
    {
        title: "Monatsübersicht",
        to: "/monatsuebersicht",
        icon: <HourglassEmpty />,
        gruppe: ["disponent", "zeiterfassung"]
        /*sub: [
            {
                title: "Disposition",
                to: "/dienstplan",
                icon: <Directions />,
            }
        ]*/
    },
    {
        title: "Zeiterfassung",
        to: "/zeiterfassung",
        icon: <WatchLater />,
        gruppe: ["zeiterfassung"]
        /*sub: [
            {
                title: "Disposition",
                to: "/dienstplan",
                icon: <Directions />,
            }
        ]*/
    },


    /*{
        title: "Stundenabrechnung",
        to: "/",
        icon: <WatchLater />
    },
    {
        title: "Rechnungseingabe",
        to: "/",
        icon: <EuroSymbol />
    },
    {
        divider: true
    },*/
    {
        title: "Ich",
        icon: <PermIdentity />,
        class: "lastItem",
        sub: [
            {
                title: "Abmelden",
                to: "/logout",
                icon: <HighlightOff />
            },
        ]
    },
]

class NewEntry extends Master {

    state = {
        me: undefined,
        doOpen: {},
    }

	componentDidMount() {
        this.props.doLoad()
    }

    getOptions = (name) => {
        if(this.state.current === name) {
            return {
                color: "primary",
                variant: "raised"
            }
        }
    }

    setOption = (current) => {
        this.setState({
            current
        })
    }

    handleClose = (key, title) => {
        var tmpKey = key+""
        var array = tmpKey.split("_")
        var last_element = array[array.length - 1]
        key = parseInt(last_element)
        this.state.doOpen[tmpKey] = false
        this.state.doOpen[key] = false
        if(title!==undefined) {
            this.setOption(title)
            return
        }
        this.setState({})
    }

    handleClick = (key, event) => {
        this.state.doOpen[key] = true
        this.setState({ anchorEl: event.currentTarget });
    }

    createSubMenu = (item, key, _subKey) => {
        if(_subKey) {
            key = "sub_"+_subKey+"_"+key
        }
        var items = (
            <Menu
                id="simple-menu"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.doOpen[key])}
                onClose={() => this.handleClose(key, item.title)}
            >
                {item.sub.map((subItem, subKey) => {
                    if(subItem.sub !== undefined) {
                        return this.createSubMenu(subItem, key, subKey)
                    }
                    return (
                        <Link to={subItem.to} className={classnames(subItem.class, "svgfix")}>
                            <MenuItem onClick={() => this.handleClose(key, item.title)}>{subItem.icon} {subItem.title && subItem.title}</MenuItem>
                        </Link>
                    )
                })}
                                            
            </Menu>
        )

        if(_subKey) {
            return (
                <div className={classnames(item.class, "svgfix")}>
                    {items}
                    <MenuItem {...this.getOptions(item.title)} aria-owns={this.state.anchorEl ? 'simple-menu' : null} aria-haspopup="true" onClick={(event) => this.handleClick(key, event)} >
                        {item.icon} {item.title && item.title}
                    </MenuItem>
                </div>
            )
        }
        
        return (
            <div className={classnames(item.class)}>
                {items}
                <Button {...this.getOptions(item.title)} aria-owns={this.state.anchorEl ? 'simple-menu' : null} aria-haspopup="true" onClick={(event) => this.handleClick(key, event)} >
                    {item.icon} {item.title && item.title}
                </Button>
            </div>
        )
    }

	render() {
        const { classes, me } = this.props
        if(!me.isLoading && me.data.id !== "") {
            var meData = me.data
            if(meData.gruppe) {
                nav = nav.map((item) => {
                    if(meData.gruppe === "admin" || item.gruppe === undefined) {
                        return item
                    }
                    if(_.indexOf(item.gruppe, meData.gruppe) >= 0) {
                        return item
                    }
                    return false
                })
            }
        }

		return (
			<AppBar position="static" color="default" className={classnames(classes.appBar, "header")}>
                    <Toolbar>
                        <div className={classes.flex}>
                            {nav.map((item, key) => {

                                if(item.disabled && item.disabled) {
                                    return
                                }
                    
                                var items = <span />
                                if(item.sub) {
                                    return this.createSubMenu(item, key)
                                }

                                if(item.to === undefined) return

                                return (
                                    <Link to={item.to} className={item.class}>
                                        <Button onClick={() => this.setOption(item.title)} {...this.getOptions(item.title)}>{item.icon}{item.title && item.title}</Button>
                                    </Link>
                                )
                            })}
                        </div>
                    </Toolbar>
                </AppBar>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/user/me", filter)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(NewEntry));


// WEBPACK FOOTER //
// ./src/Header.js